import React from "react";

export function CapexTooltipContent({ active, payload, label, privacy, fmt }) {
  if (!active || !Array.isArray(payload) || payload.length === 0) return null;

  const point = payload[0]?.payload || {};
  const showValue = (value) => (privacy ? "•••" : fmt(value));
  const capex = Number(point.capex) || 0;
  const rows = [
    { label: "Net", value: point.value },
    { label: "Prior yr", value: point.prior },
  ];

  return (
    <div className="rounded-md border border-border bg-card px-3 py-2 text-[12px] shadow-sm">
      {label ? <p className="mb-1 font-semibold text-foreground">{label}</p> : null}
      {rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">{row.label}</span>
          <span className="tabular-nums text-foreground">{showValue(row.value)}</span>
        </div>
      ))}
      {capex > 0 ? (
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Capital improvements:</span>
          <span className="tabular-nums text-foreground">{showValue(capex)}</span>
        </div>
      ) : null}
    </div>
  );
}
